import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { resources, SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from './resources';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: false,
    ns: [
      'admin',
      'auth',
      'autopilot',
      'common',
      'company',
      'credits',
      'fixedRoutes',
      'licensing',
      'map',
      'mapCore',
      'mapDialogs',
      'mapDownload',
      'mapTransfer',
      'mapWizards',
      'navigation',
      'onboarding',
      'profile',
      'sharing',
      'simulation',
      'tools',
      'whatsNew',
    ],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'atlas_language',
      caches: ['localStorage'],
    },
    returnNull: false,
  });

export default i18n;
